const baseURLVer1 = `/api/v1/control/passport`;

export default {
  /**
   * @GET 관리자용 Passport 검색
   */
  CONTROL_PASSPORT_SEARCH: `${baseURLVer1}/search`,
};
